<template>
  <v-card flat>
    <v-card-text>
      <p>
        A verification link will be emailed to your new email address shortly.
        Please click on the link to verify that the email belongs to you.
      </p>
      <v-form @submit.prevent="sendEmailConfirmation" v-model="valid" ref="form">
        <v-text-field
          label="Email"
          v-model="email"
          type="email"
          :rules="rules"
          required
          hint="Updating your email address will change your login credentials."
          :success-messages="
            confirmationSent ? ['We have sent an email to you to confirm this change'] : []
          "
          :color="themes.candidate.light.input"
        />
        <div class="text-xs-right">
          <v-btn
            :color="themes.candidate.light.cancel"
            @click="$emit('done')"
            flat
          >
          Skip
          </v-btn>
          <v-btn
            :class="themes.candidate.light.primaryActionButton"
            type="submit"
            :disabled="!valid || confirmationSent"
          >
            Send and Continue
          </v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Validation
const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  mounted() {
    if (this.user && this.user.email) this.email = this.user.email
  },

  data() {
    return {
      // Model
      email: '',

      // Toggle
      confirmationSent: false,

      // Validation
      valid: true,
      rules: [v => !!v || 'Email is required', v => emailPattern.test(v) || 'Email must be valid'],
    }
  },

  computed: mapGetters({ user: 'auth/user' }),

  methods: {
    sendEmailConfirmation() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch('candidate/candidate/update', { ...this.user, email: this.email })
          .then(() => {
            this.confirmationSent = true
            this.$emit('done')
            this.$emit('input')
          })
      }
    },
  },
}
</script>
